module.exports = "<div class=\"login-template-wrapper\">\r\n    <wow-login-header></wow-login-header>\r\n    <div ui-view=\"login-content\"></div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/views/login.html
 ** module id = 1043
 ** module chunks = 1
 **/